module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Pound-9b9040190cd0b2337e5ea7690219a613.svg";